<app-header [b2sContent]="b2sContent"></app-header>

<router-outlet></router-outlet>

<app-footer [b2sContent]="b2sContent"></app-footer>
